function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyCreditcheckMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 13.875H12.3C13.425 13.875 13.875 13.425 13.875 12.3V10.95C13.875 9.825 13.425 9.375 12.3 9.375H9.45C8.325 9.375 7.875 9.825 7.875 10.95V12.3C7.875 13.425 8.325 13.875 9.45 13.875Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyCreditcheckMobileNav);
export default __webpack_public_path__ + "static/media/easy-creditcheck-mobile-nav.67d677f80865647f8e6d8a92df443996.svg";
export { ForwardRef as ReactComponent };